module.exports = __webpack_public_path__ + "img/3.d3c271e3.png";